// Shared CSV helpers. One implementation of RFC-4180 quoting and of the
// browser download, so export pages stop growing their own copies.

//: A leading character that makes Excel, Sheets and Numbers read a cell as a
//: formula. Customer-typed text (names, notes) can start with any of them.
const FORMULA_TRIGGERS = /^[=+\-@\t\r]/

// RFC-4180 cell: quote when it contains a comma, quote, or newline; double
// internal quotes.
export function csvCell(value) {
  const s = value == null ? '' : String(value)
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

// For text a customer typed. A leading apostrophe stops a spreadsheet running
// "=HYPERLINK(...)" typed into a name field (CSV formula injection).
export function safeCsvCell(value) {
  const s = value == null ? '' : String(value)
  return csvCell(FORMULA_TRIGGERS.test(s) ? `'${s}` : s)
}

// Canonical UTC "YYYY-MM-DD HH:MM:SS": sortable and unambiguous. Falls back
// to the raw value when it does not parse.
export function csvTimestamp(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? String(iso) : d.toISOString().replace('T', ' ').slice(0, 19)
}

export function downloadCsv(content, filename) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
